<template lang="pug">
    div
        v-row
            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsOnline | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents online
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-account

            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsIdle | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents idle
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-bullhorn

            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsInMessageCenter | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents in message center
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-cellphone

        v-row
            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsOnInboundCalls | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents on inbound call
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-phone-incoming

            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsOnOutboundCalls | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents on outbound call
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-phone-outgoing

            v-col(cols='4')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsInWrapUp | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents in wrap up
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-bell

</template>

<script lang="ts">
    import Vue from 'vue';

    // Helpers
    import { arraysHaveAtLeastOneCommonElement } from "@/helpers/array";

    export default Vue.extend({
        data() {
            return {
                renderAgents: [],
                stats: {
                    totalAgentsOnline: 0,
                    totalAgentsIdle: 0,
                    totalAgentsInMessageCenter: 0,
                    totalAgentsInWrapUp: 0,
                    totalAgentsOnInboundCalls: 0,
                    totalAgentsOnOutboundCalls: 0,
                },
            }
        },
        methods: {
            calculateAgentCounts() {
                if (!this.validAgents) {
                    return;
                }

                // Init
                let totalAgentsOnline = 0;
                let totalAgentsIdle = 0;
                let totalAgentsInMessageCenter = 0;
                let totalAgentsInWrapUp = 0;
                let totalAgentsOnInboundCalls = 0;
                let totalAgentsOnOutboundCalls = 0;

                // Loop through agents and build counts
                // Note - agents can be in multiple buckets, so need to do this with if statements
                for (let i = 0; i < this.agents.length; i++) {

                    // Load agent
                    const agent = this.agents[i];
                    if (!agent) {
                        continue;
                    }

                    // If the agent isn't online, move on
                    if (agent.is_online !== true) {
                        continue;
                    }

                    // If valid filter obj, filter accessible
                    if (!!this.filterObj) {

                        // Teams
                        if (this.filterObj.teamIds?.length > 0) {

                            // Verify that they share at least one common element
                            if (!(arraysHaveAtLeastOneCommonElement((agent.team_ids || []), this.filterObj.teamIds))) {
                                continue
                            }
                        }
                    }

                    // Add to online total
                    totalAgentsOnline++;

                    // 4 is non-production, which is idle
                    if (agent.agent_status_type === 4) {
                        totalAgentsIdle++;
                    } else if (agent.agent_status_type === 6) { // 6 is message center
                        totalAgentsInMessageCenter++;
                    } else {

                        // Check status name for call specific boxes
                        switch(agent.agent_status_name) {
                        case "Inbound Wrap Up":
                            totalAgentsInWrapUp++;
                            break;
                        case "Incoming Call":
                            totalAgentsOnInboundCalls++;
                            break;
                        case "Outgoing Call":
                            totalAgentsOnOutboundCalls++;
                            break;
                        case "Outbound Wrap Up":
                            totalAgentsInWrapUp++;
                            break;
                        }
                    }
                }

                // Set stats
                this.stats.totalAgentsOnline = totalAgentsOnline;
                this.stats.totalAgentsIdle = totalAgentsIdle;
                this.stats.totalAgentsInMessageCenter = totalAgentsInMessageCenter;
                this.stats.totalAgentsInWrapUp = totalAgentsInWrapUp;
                this.stats.totalAgentsOnInboundCalls = totalAgentsOnInboundCalls;
                this.stats.totalAgentsOnOutboundCalls = totalAgentsOnOutboundCalls;
            },
        },
        computed: {
            validAgents() {
                return this.agents?.length > 0;
            },
        },
        components: {
        },
        props: {
            agents: Array,
            filterObj: Object,
        },
        watch: {
            agents: {
                deep: true, // This will let Vue know to look inside the array
                handler() {
                    this.calculateAgentCounts();
                },
            },
            filterObj: {
                deep: true, // This will let Vue know to look inside the array
                handler() {
                    this.calculateAgentCounts();
                },
            },
        },
        created() {
            this.calculateAgentCounts();
        },
    });
</script>

<style lang="scss" scoped>
</style>